import { IApiRequestConfig } from '../api.types';

export const getMeetingTemplatesApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMeetingTemplates',
  uri: 'json',
  action: `meeting-templates`,
  method: 'get',
  v2: true,
});
